import { render, staticRenderFns } from "./admin-nrr.vue?vue&type=template&id=dcac1e66&scoped=true&"
import script from "./admin-nrr.vue?vue&type=script&lang=js&"
export * from "./admin-nrr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcac1e66",
  null
  
)

export default component.exports